
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserRoomStateData, User, MessageHistory } from '@/utils/models';
@Component({ components: {} })
export default class MessageDisplayer extends Vue {
  @Prop() userData!: UserRoomStateData;
  @Prop() isConnecting!: boolean;
  @Prop() userMessage!: string;
  @Prop() scale!: number;
  @Emit()
  onRemoveMessage() {}

  messageContainerWidth = 25;
  messageFirstlineWidth = 25;
  private allSentenceTimer: any = 0;
  private hoverMessageTimer: any = 0;
  showAllSentence = true;
  isHoverMessage = false;

  get isMyself(): boolean {
    return this.$store.state.user.id === this.userData.userState.user.id;
  }
  get messeageAreaWidth(): string {
    return this.showAllSentence || this.isHoverMessage
      ? this.messageContainerWidth + 'px'
      : this.messageFirstlineWidth + 'px';
  }
  mounted() {
    this.onUserMessageChanged(this.userMessage, '');
  }
  @Watch('userMessage')
  onUserMessageChanged(newMessage: string, oldMessage: string) {
    clearTimeout(this.allSentenceTimer);
    if (newMessage) {
      let canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) {
        return;
      }
      context.font = "16px 'Noto Sans JP'";
      const metrics = newMessage.split('\n').map((s) => context.measureText(s).width);
      const width = Math.max(...metrics);
      if (metrics[1]) {
        this.messageFirstlineWidth = metrics[0] + 16;
      } else {
        this.messageFirstlineWidth = metrics[0];
      }
      this.messageContainerWidth = Math.min(210, width);
      this.showAllSentence = true;
      this.allSentenceTimer = setTimeout(() => {
        this.showAllSentence = false;
      }, 10 * 1000);
    } else {
      this.messageContainerWidth = 25;
    }
  }
  onEnterMessage() {
    clearTimeout(this.hoverMessageTimer);
    this.isHoverMessage = true;
  }
  onLeaveMessage() {
    this.hoverMessageTimer = setTimeout(() => {
      this.isHoverMessage = false;
    }, 10 * 1000);
  }
  onClick(ev: MouseEvent) {
    ev.stopPropagation();
  }
}
